export var actionTypePrefix = '@@comments';
export var reduxKey = '@@comments';
export var actionMenuWidthMobile = 'auto';
export var actionMenuWidthDesktop = 140;
//# sourceMappingURL=constants.js.map